import { render } from "./ControlPage.vue?vue&type=template&id=517ecbd0&scoped=true"
import script from "./ControlPage.vue?vue&type=script&lang=js"
export * from "./ControlPage.vue?vue&type=script&lang=js"

import "./ControlPage.vue?vue&type=style&index=0&id=517ecbd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517ecbd0"]])

export default __exports__